<template>
  <div class="earn">
    <h5 style="font-weight: bold">โอน Coin ให้ลูกค้า</h5>
    <div class="row mt-4">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <div>
          <header style="font-weight: bold">1. วิธีการโอน</header>
        </div>
        <hr />
        <el-select
          ref="transferMethods"
          v-model="transferId"
          style="width: 100%"
          placeholder="เลือกวิธีการโอน"
        >
          <el-option
            v-for="item in transferMethods"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <!-- Transfer Type Selection -->
        <div class="mt-2">
          <label :class="!transferId ? 'disabled' : ''" class="select-input">
            <span>ค้นหารายบุคคล</span>
            <input
              v-model="transferType"
              :disabled="!transferId"
              type="radio"
              value="individual"
              name="transferType"
            />
            <span
              :class="!transferId ? 'disabled' : ''"
              class="checkmark radio"
            ></span>
          </label>

          <label
            :class="!transferId ? 'disabled' : ''"
            class="select-input mt-2"
          >
            <span>อัปโหลดไฟล์ Excel (โอนหลายคนพร้อมกัน)</span>
            <input
              v-model="transferType"
              :disabled="!transferId"
              type="radio"
              value="bulk"
              name="transferType"
            />
            <span
              :class="!transferId ? 'disabled' : ''"
              class="checkmark radio"
            ></span>
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <!-- User Selection -->
        <div v-if="isIndividualTransfer" class="user-selection">
          <user-list
            v-model="users"
            :can-select-one-user="true"
            :is-filter-tokenx-user="true"
            :transfer-id="transferId"
          ></user-list>
        </div>

        <!-- Excel Upload Section -->
        <div v-if="isBulkTransfer" class="mt-2">
          <header style="font-weight: bold">อัพโหลดไฟล์ Excel</header>
          <hr />
          <input
            ref="excelFile"
            :disabled="!transferId || isProcessingExcel"
            type="file"
            accept=".xlsx,.xls"
            @change="handleFileUpload"
          />

          <!-- Loading Overlay -->
          <LoadingOverlay :active="isProcessingExcel" />
        </div>

        <!-- Excel Data Table -->
        <div v-if="showExcelTable && isBulkTransfer" class="mt-4">
          <header style="font-weight: bold">ข้อมูลจากไฟล์ Excel</header>
          <hr />
          <div class="excel-table-container">
            <DataTable
              :data="excelData"
              :headers="tableHeaders"
              :loading="isProcessingExcel"
            />
          </div>

          <div class="mt-2">
            <small class="text-info">
              จำนวนรายการทั้งหมด: {{ excelData.length }}
            </small>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <div>
          <header style="font-weight: bold">3. แคมเปญ</header>
        </div>
        <hr />
        <el-select
          ref="campaigns"
          v-model="selectedCampaign"
          :disabled="!transferId || !isCampaignEarn"
          style="width: 100%"
          placeholder="เลือกแคมเปญ"
          clearable
          value-key="id"
        >
          <el-option
            v-for="item in campaigns"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <header style="font-weight: bold">4. เลือกกระเป๋าในการ transfer</header>
        <div class="mt-3">
          <div v-for="wallet in walletList" :key="wallet.title">
            <label
              :class="isEnabledOrgWallet ? '' : 'disabled'"
              class="select-input"
            >
              <span>{{ wallet.title }}</span>
              <input
                v-model="walletSelect"
                :value="wallet.value"
                :disabled="!isEnabledOrgWallet"
                type="radio"
                name="wallet"
              />
              <span
                :class="isEnabledOrgWallet ? '' : 'disabled'"
                class="checkmark radio"
              ></span>
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
        <header style="font-weight: bold">5. จำนวน Coin ที่ต้องการโอน</header>
        <hr />
        <el-input-number
          v-model="coinAmount"
          :disabled="
            !transferId ||
            (isCampaignEarn && (!selectedCampaign || hasCampaignCoinAmount))
          "
          :controls="false"
          :precision="0"
          type="number"
        ></el-input-number>
        <div class="mt-4">
          <header style="font-weight: bold">
            หมายเหตุ
            <div class="optional" style="font-weight: normal">(optional)</div>
          </header>
        </div>
        <hr />
        <el-input v-model="note" :disabled="!transferId" type="textarea" />
      </div>
      <div style="width: 100%; text-align: end; margin-right: 16px">
        <sc-button
          :disabled="isViewOnlyByRole"
          variant="primary"
          @click="handleSubmit"
          >บันทึก</sc-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient, backendAdminClient } from "@/dependencies";
import DataTable from "@/lib/components/DataTable";
import LoadingOverlay from "@/lib/components/LoadingOverlay";
import ScButton from "@/lib/components/ScButton";
import {
  formatDecimal,
  roundToTwoAndMultiplyOneHundred,
} from "@/lib/formatter";

import { Input } from "element-ui";
import * as XLSX from "xlsx";

import UserList from "../../managements/modules/messaging/components/UserList";

export default {
  components: {
    "user-list": UserList,
    "el-input": Input,
    "sc-button": ScButton,
    LoadingOverlay,
    DataTable,
  },
  data() {
    let permission = null;

    try {
      permission = JSON.parse(localStorage.getItem("adminRolePermission"));
    } catch (error) {
      permission = null;
    }

    permission = permission && typeof permission === "object"
      ? permission
      : { role: null };

    let transferMethods = [];
    if (permission.role === "NSMNC" || permission.role === "JUMNC") {
      transferMethods = [{ id: 2, name: "โอนผูกแคมเปญ" }];
    } else {
      transferMethods = [
        { id: 1, name: "โอนตรงให้ลูกค้า" },
        { id: 2, name: "โอนผูกแคมเปญ" },
      ];
    }

    return {
      users: [],
      coinAmount: null,
      note: null,
      walletDropdown: [],
      walletSelect: null,
      permission,
      transferMethods,
      transferId: null,
      campaigns: [],
      excelData: [],
      showExcelTable: false,
      transferType: "individual",
      isProcessingExcel: false,
      tableHeaders: [
        {
          value: "index",
          label: "ลำดับ",
          width: "80px",
          formatter: (row, column, cellValue, index) => index + 1,
        },
        {
          value: "userId",
          label: "User ID",
          width: "120px",
        },
        {
          value: "firstName",
          label: "ชื่อจริง",
          width: "120px",
        },
        {
          value: "lastName",
          label: "นามสกุล",
          width: "120px",
        },
        {
          value: "homeAddress",
          label: "บ้านเลขที่",
          width: "130px",
        },
        {
          value: "project",
          label: "โครงการ",
        },
        {
          value: "projectCode",
          label: "รหัสโครงการ",
          width: "120px",
        },
      ],
      selectedCampaign: null,
    };
  },
  computed: {
    isViewOnlyByRole() {
      const roles = ["CC"];
      const role = this.permission && this.permission.role;

      return roles.includes(role);
    },
    isIndividualTransfer() {
      return this.transferType === "individual";
    },
    isBulkTransfer() {
      return this.transferType === "bulk";
    },
    isEnabledOrgWallet() {
      return (
        this.transferId === 1 ||
        (this.transferId === 2 && this.selectedCampaign)
      );
    },
    walletList() {
      if (this.selectedCampaign) {
        const targetUsedFor = this.selectedCampaign.used_for || "SCASSET";
        return this.walletDropdown.filter(
          (wallet) => wallet.used_for === targetUsedFor
        );
      }

      return this.walletDropdown;
    },
    isCampaignEarn() {
      return this.transferId === 2;
    },
    hasCampaignCoinAmount() {
      return Number(this.selectedCampaign?.coin_amount) > 0;
    },
  },
  watch: {
    async transferId(val) {
      if (val) {
        if (this.$refs.transferMethods && this.$refs.transferMethods.blur) {
          this.$refs.transferMethods.blur();
        }

        this.selectedCampaign = null;

        try {
          await this.setupCampaignList();
        } catch (error) {
          this.$message.error("ไม่สามารถโหลดแคมเปญได้");
        }
      }
    },
    transferType(newType, oldType) {
      if (newType !== oldType) {
        if (newType === "individual") {
          this.resetExcelData();
        } else if (newType === "bulk") {
          this.users = [];
        }
      }
    },
    selectedCampaign(val) {
      if (val) {
        if (this.$refs.campaigns && this.$refs.campaigns.blur) {
          this.$refs.campaigns.blur();
        }
        this.setCoinAmount();
        this.setWalletSelectBySelectedCampaign();
      } else {
        // กรณี Clear หรือไม่ได้เลือก
        this.coinAmount = null;
        this.setDefaultWalletSelect();
      }
    },
  },
  async created() {
    await this.setupWallet();
  },
  mounted() {
    this.focusTransferMethodsInput();
  },
  methods: {
    clearFileInput() {
      if (this.$refs.excelFile) {
        this.$refs.excelFile.value = "";
      }
    },
    resetExcelData() {
      this.excelData = [];
      this.showExcelTable = false;
      this.clearFileInput();
    },
    getCampaignTransferMeta() {
      if (!this.isCampaignEarn || !this.selectedCampaign) {
        return {
          earnCampaignId: undefined,
          earnCampaignName: undefined,
          tokenId: undefined,
        };
      }

      return {
        earnCampaignId: this.selectedCampaign.id,
        earnCampaignName: this.selectedCampaign.name,
        tokenId: this.selectedCampaign.tokenId,
      };
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.isProcessingExcel = true;
      this.processExcelFile(file);
    },
    validateExcelHeader(headerRow) {
      if (!headerRow || headerRow.length === 0) {
        return {
          isValid: false,
          message: "ไม่พบ header ในไฟล์ Excel",
        };
      }

      const actualHeaders = headerRow.map((header) =>
        header ? String(header).trim().toLowerCase() : ""
      );

      const requiredHeaders = ["userid"];
      const missingRequired = requiredHeaders.filter(
        (required) =>
          !actualHeaders.some((actual) =>
            actual.includes(required.toLowerCase())
          )
      );

      if (missingRequired.length > 0) {
        return {
          isValid: false,
          message: "Format Excel ไม่ถูกต้อง",
        };
      }

      return {
        isValid: true,
        message: "Header ของไฟล์ Excel ถูกต้อง",
        mappedHeaders: actualHeaders,
      };
    },
    processExcelData(jsonData) {
      if (jsonData.length === 0) {
        this.$message.error("ไฟล์ Excel ว่างเปล่า");
        return;
      }

      const headerRow = jsonData[0];
      const headerValidation = this.validateExcelHeader(headerRow);

      if (!headerValidation.isValid) {
        this.$message.error(headerValidation.message);
        this.resetExcelData();
        return;
      }

      // Skip header row
      const dataRows = jsonData.slice(1);

      this.excelData = dataRows
        .map((row, index) => {
          const userId = row[0] ? String(row[0]).trim() : null;
          const firstName = row[1] ? String(row[1]).trim() : null;
          const lastName = row[2] ? String(row[2]).trim() : null;
          const homeAddress = row[3] ? String(row[3]).trim() : null;
          const project = row[4] ? String(row[4]).trim() : null;
          const projectCode = row[5] ? String(row[5]).trim() : null;

          // Enhanced validation
          const validationResult = this.validateRowData({
            userId,
            firstName,
            lastName,
            homeAddress,
            project,
            projectCode,
            rowIndex: index + 2,
          });

          return {
            userId,
            firstName,
            lastName,
            homeAddress,
            project,
            projectCode,
            isValid: validationResult.isValid,
            originalIndex: index,
          };
        })
        .filter((row) => row.isValid);

      this.showExcelTable = true;

      if (this.excelData.length === 0) {
        this.$message.error("ไม่พบข้อมูลที่ถูกต้องในไฟล์ Excel");
        this.resetExcelData();
      }
    },
    validateRowData(data) {
      const errors = [];
      const { userId } = data;

      // User ID validation (required)
      if (!userId) {
        errors.push("ไม่มี User ID");
      } else if (!/^\d+$/.test(userId)) {
        errors.push(`User ID "${userId}" ต้องเป็นตัวเลขเท่านั้น`);
      }

      return {
        isValid: errors.length === 0,
        errors,
      };
    },
    async handleSubmit() {
      if (!this.transferId) {
        this.$message.error("กรุณาเลือกวิธีการโอน");
        return;
      }

      // Validate based on transfer type
      if (this.isIndividualTransfer) {
        if (!this.users || this.users.length === 0) {
          this.$message.error("กรุณาเลือกลูกบ้าน");
          return;
        }
      } else if (this.isBulkTransfer) {
        if (!this.excelData || this.excelData.length === 0) {
          this.$message.error("กรุณาอัพโหลดไฟล์ Excel");
          return;
        }

        const validData = this.excelData.filter((row) => row.isValid);
        if (validData.length === 0) {
          this.$message.error("ไม่มีข้อมูลที่ถูกต้องในไฟล์ Excel");
          return;
        }
      }

      if (this.transferId && this.isCampaignEarn && !this.selectedCampaign) {
        this.$message.error("กรุณาเลือกแคมเปญ");
        return;
      }

      if (!this.walletSelect) {
        this.$message.error("กรุณาเลือก กระเป๋า ในการ transfer");
        return;
      }

      if (
        this.coinAmount === null
        || this.coinAmount === undefined
        || this.coinAmount === ""
      ) {
        this.$message.error("กรุณากรอกจำนวน MNC ที่ต้องการโอนให้ลูกบ้าน");
        return;
      }

      try {
        const amount = formatDecimal(parseFloat(this.coinAmount));

        if (this.isIndividualTransfer) {
          await this.$confirm(
            `ต้องการโอน MNC ให้คุณ "${this.users[0].name} ${amount} coin"`,
            "ยืนยันการโอน",
            {
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก",
              type: "warning",
            }
          );

          await this.performIndividualTransfer(amount);
        } else if (this.isBulkTransfer) {
          // Bulk transfer
          const validData = this.excelData.filter((row) => row.isValid);

          await this.$confirm(
            `ต้องการโอน MNC จำนวน ${amount} coin ให้ลูกบ้านจำนวน ${validData.length} คน?`,
            "ยืนยันการโอน",
            {
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก",
              type: "warning",
            }
          );

          await this.performBulkTransfer(amount, validData);
        }
      } catch (error) {
        if (error !== "cancel" && error !== "close") {
          this.$message.error("ไม่สามารถโอนเงินเข้าลูกบ้านได้");
        }
      }
    },
    async performIndividualTransfer(amount) {
      const { earnCampaignId, earnCampaignName } = this.getCampaignTransferMeta();

      const params = {
        user_id: this.users[0].id.toString(),
        amount: roundToTwoAndMultiplyOneHundred(amount),
        note: this.note || undefined,
        wallet_name: this.walletSelect,
        earn_campaign_id: earnCampaignId,
        earn_campaign_name: earnCampaignName,
      };

      await baanRueJaiClient.admin.tokenx.send(params);

      this.$message.success("โอนเงินเข้าลูกบ้านเรียบร้อย");
      this.clearSetupData();
    },
    async performBulkTransfer(amount, validData) {
      const { earnCampaignId, earnCampaignName, tokenId } = this.getCampaignTransferMeta();

      // Process each valid user
      const transferData = {
        wallet_name: this.walletSelect,
        note: this.note || undefined,
        coin_amount: roundToTwoAndMultiplyOneHundred(amount),
        coin_earn_campaign_id: earnCampaignId,
        earn_campaign_name: earnCampaignName,
        token_id: tokenId,
        to_wallet_data: validData.map((row) => row.userId),
      };

      // Send bulk transfer request
      await backendAdminClient.morningCoin.bulkTransferFromOrg(transferData);

      this.$message.success("โอนเงินเข้าลูกบ้านเรียบร้อย");
      this.clearSetupData();
    },
    setDefaultWalletSelect() {
      this.walletSelect =
        this.walletDropdown && this.walletDropdown[0] && this.walletDropdown[0].value
          ? this.walletDropdown[0].value
          : null;
    },
    setWalletSelectBySelectedCampaign() {
      if (!this.selectedCampaign) {
        return;
      }

      const targetUsedFor = this.selectedCampaign.used_for || "SCASSET";
      const filteredWallets = this.walletDropdown.filter(
        (wallet) => wallet.used_for === targetUsedFor
      );

      this.walletSelect =
        filteredWallets && filteredWallets[0] && filteredWallets[0].value
          ? filteredWallets[0].value
          : null;
    },
    clearSetupData() {
      this.transferId = null;
      this.users = [];
      this.coinAmount = null;
      this.note = null;
      this.walletSelect = this.walletDropdown && this.walletDropdown[0]
        ? this.walletDropdown[0].value
        : null;
      this.resetExcelData();
      this.transferType = "individual";
      this.isProcessingExcel = false;
      this.selectedCampaign = null;
      this.campaigns = [];
    },
    async setupWallet() {
      const wallets =
        await baanRueJaiClient.admin.tokenx.getOrganizationWalletAdminCanTransferList();
      this.walletDropdown = Object.freeze(wallets);
      this.setDefaultWalletSelect();
    },
    async setupCampaignList() {
      if (this.isCampaignEarn && this.campaigns.length === 0) {
        this.campaigns = Object.freeze(
          await baanRueJaiClient.admin.tokenx.getAllEarnCampaignList()
        );
      }
    },
    focusTransferMethodsInput() {
      if (this.$refs.transferMethods && this.$refs.transferMethods.focus) {
        this.$refs.transferMethods.focus();
      }
    },
    processExcelFile(file) {
      // Check file type
      const validExtensions = ["xlsx", "xls"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        this.$message.error("กรุณาเลือกไฟล์ Excel (.xlsx หรือ .xls) เท่านั้น");
        this.isProcessingExcel = false;
        this.clearFileInput();
        return;
      }

      // Check file size (limit to 10MB)
      const maxFileSize = 10 * 1024 * 1024;
      if (file.size > maxFileSize) {
        this.$message.error("ไฟล์มีขนาดใหญ่เกินไป (สูงสุด 10MB)");
        this.isProcessingExcel = false;
        this.clearFileInput();
        return;
      }

      // Read Excel file
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          // Get first sheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          this.processExcelData(jsonData);
        } catch (error) {
          this.$message.error("ไม่สามารถอ่านไฟล์ Excel ได้ กรุณาตรวจสอบรูปแบบไฟล์");
        } finally {
          this.isProcessingExcel = false;
        }
      };

      reader.onerror = () => {
        this.$message.error("เกิดข้อผิดพลาดในการอ่านไฟล์");
        this.isProcessingExcel = false;
        this.clearFileInput();
      };

      reader.readAsArrayBuffer(file);
    },
    setCoinAmount() {
      // ต้องเช็คก่อนว่า selectedCampaign มีค่าหรือไม่
      if (this.selectedCampaign) {
        this.coinAmount = this.selectedCampaign.coin_amount ?? null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.earn {
  padding: 15px;
}

.header {
  font-size: 16px;
  font-weight: normal;
}

.optional {
  font-size: 14px;
  display: inline;
}

.user-selection {
  transition: opacity 0.3s ease;
}

.user-list-disabled {
  pointer-events: none;
  opacity: 0.5;
}

.excel-table-container {
  max-height: 400px;
  overflow-y: auto;
}
</style>
